export enum SocialIntent {
  BUSY = 'BUSY',
  OPEN_INVITE = 'OPEN_INVITE',
  CATALYST = 'CATALYST',
  SIGNAL = 'SIGNAL',
  BEACON = 'BEACON',
}

export enum VisibilityScope {
  PRIVATE = 'PRIVATE',
  INNER_CIRCLE = 'INNER_CIRCLE',
  EXTENDED = 'EXTENDED',
}

export interface SocialEvent {
  id: string;
  title: string;
  startTime: number; // Unix timestamp
  endTime: number;   // Unix timestamp
  intent: SocialIntent;
  visibilityScope: VisibilityScope;
  maxParticipants?: number;
  currentParticipants: string[]; // Array of user IDs
  description?: string;
  location?: string;
  isDragging?: boolean;
}
